var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('nav',_vm._l((_vm.myrouter),function(v,k){return _c('router-link',{key:k,attrs:{"to":v.url,"tag":"div","active-class":"checked","replace":""}},[_vm._v(" "+_vm._s(v.name)+" ")])}),1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }